module.exports = __webpack_public_path__ + "img/desc.6766ee50.svg";